import { ILine } from '../../global';
import { sortByDate } from '../sorting';

export function getLinesForProduct(lines: ILine[], productId: string): ILine[] {
  return lines.filter((line) => line.product === productId);
}

export function getLastLine(lines: ILine[]): ILine {
  return sortByDate([...lines], 'start', 'desc')[0];
}
